import { axios, BaseOpenApiUrl,BaseApiUrl } from '../axios_config';

// 查询入库单
export const getMakeAppointmentList = params =>{
    return axios.get(`${BaseOpenApiUrl}/MakeAppointmen/GetMakeAppointmentList`, { params }).then(res => res.data);
}
//到场核收
export const getAppointmentCheck = params =>{
    return axios.get(`${BaseOpenApiUrl}/MakeAppointmen/GetAppointmentCheck`, { params }).then(res => res.data);
}

// 查询入库单
export const getBatchMakeAppointmentList = params =>{
    return axios.get(`${BaseOpenApiUrl}/MakeAppointmen/GetBatchMakeAppointmentList`, { params }).then(res => res.data);
}

// 查询入库单
export const getMakeAppointmentListDev = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetMakeAppointmentList`, { params }).then(res => res.data);
}

// 发送验证码
export const sendCode = params =>{
    return axios.get(`${BaseOpenApiUrl}/MakeAppointmen/SendVerificationCode`, { params }).then(res => res.data);
}

// 预约入库
export const addBookingDelivery = params =>{
    return axios.post(`${BaseOpenApiUrl}/MakeAppointmen/AddBookingDelivery`, { ...params }).then(res => res.data);
}
// 预约入库
export const addBookingDeliveryBatch = params =>{
    return axios.post(`${BaseOpenApiUrl}/MakeAppointmen/AddBookingDeliveryBatch`, { ...params }).then(res => res.data);
}
//到仓证明
export const addAppointArrive = params =>{
    return axios.post(`${BaseOpenApiUrl}/MakeAppointmen/AddAppointArrive`, { ...params }).then(res => res.data);
}

// 查询预约单
export const getMakeAppointmentQuery = params =>{
    return axios.get(`${BaseOpenApiUrl}/MakeAppointmen/GetMakeAppointmentQuery`, { params }).then(res => res.data);
}

// 修改预约信息
export const editBookingDelivery = params =>{
    return axios.post(`${BaseOpenApiUrl}/MakeAppointmen/EditBookingDelivery`, { ...params }).then(res => res.data);
}

// 取消预约
export const editBookingStatus = params =>{
    return axios.post(`${BaseOpenApiUrl}/MakeAppointmen/EditBookingStatus`, { ...params }).then(res => res.data);
}

// 修改预约时间
export const editSuggestTime = params =>{
    return axios.post(`${BaseOpenApiUrl}/MakeAppointmen/EditSuggestTime`, { ...params }).then(res => res.data);
}

// 查询预约单
export const GetBookingPro = params =>{
    return axios.get(`${BaseOpenApiUrl}/MakeAppointmen/GetBookingPro`, { params }).then(res => res.data);
}

// 获取预约假期
export const getBookHoliday = params => {
    return axios.get(`${BaseOpenApiUrl}/MakeAppointmen/GetBookHoliday`, { params }).then(res => res.data);
}